import AsyncStorage from '@react-native-community/async-storage';

export const TOKEN_KEY = '@SenaiVagas:token'
export const ALUNO_KEY = '@SenaiVagas:aluno'

export const onSignIn = aluno => {
  AsyncStorage.setItem(TOKEN_KEY, aluno.token)
  delete aluno.token
  AsyncStorage.setItem(ALUNO_KEY, JSON.stringify(aluno.aluno))
}

export const onSignOut = () => {
  AsyncStorage.removeItem(TOKEN_KEY)
  AsyncStorage.removeItem(ALUNO_KEY)
}

export const getToken = async () => await AsyncStorage.getItem(TOKEN_KEY)

export const getAluno = async () =>
  JSON.parse(await AsyncStorage.getItem(ALUNO_KEY))

export const setAluno = async aluno =>
  AsyncStorage.setItem(ALUNO_KEY, JSON.stringify(aluno))

export const isSignedIn = async () => {
  const token = await AsyncStorage.getItem(TOKEN_KEY)

  return token !== null ? true : false
}
